import { XCircle } from '@phosphor-icons/react';
import { withMagneticIcon } from '../withMagneticIcon.js';

const Icon = withMagneticIcon(XCircle);
Icon.displayName = "XCircle";

export { Icon as XCircle };
//# sourceMappingURL=XCircle.js.map
